<template>
  <div class="canvas">
      <van-steps :active="step">
  <van-step>1</van-step>
  <van-step>2</van-step>
  <van-step>3</van-step>
  <van-step>4</van-step>
</van-steps>
    <div>
      <canvas ref="canvas"></canvas>
    </div>

    <SetBackgound @bgimg="bgimg" @quit="quit" v-show="step === 0">
    </SetBackgound>

    <MyPattern
      v-show="step === 1"
      @quit="quit"
      @selectImg="selectImg"
      @setText="setText"
      @selectColor="selectColor"
      @rotate="rotate"
    >
    </MyPattern>

    <div class="next" v-show="nextBtnShow && step < 2">
      <button @click="nextStep(1)">上一步</button>
      <button @click="nextStep(2)">下一步</button>
    </div>

      <div class="btn" v-show="step === 2">
        <!-- <button></button> -->
        <button >收藏卡片</button>
        <button @click="save">保存到相册</button>
      </div>
  </div>
</template>
<script>
import Backgound from "./components/backgound.vue";
import Pattern from "./components/pattern";
import { Step, Steps } from 'vant';
export default {
  name: "makingCard",
  components: {
    SetBackgound: Backgound,
    MyPattern: Pattern,
    [Step.name]: Step,
    [Steps.name]: Steps,
  },
  data() {
    return {
      nextBtnShow: true,
      show: "",
      step: 0, // 1:设置背景 2:贴入文字或图案 3:生成图片
      cBgImg: "", //选中的背景
      canvas: "", //canvas
      cardStore: [], //   所有图案
      index: 0, // 选中的元素坐标
      roundP: { x: 0, y: 0, w: 0, h: 0 }, //删除小圆圈坐标
      imgObj: "", //删除小圆圈图
      is_touches: false, //是否两根手指进入 开关
      pstart: [0, 0], //双指进入开始坐标
    };
  },
  methods: {
    // 选中的边框坐标
    select() {
      let { x, y, w, h } = this.cardStore[this.index];
      let ctx = this.canvas.getContext("2d");
      // 选中边框
      ctx.lineDashOffset = 3;
      ctx.setLineDash([3, 3, 3]);
      ctx.moveTo(x, y);
      ctx.lineTo(x + w, y);
      ctx.strokeStyle = "#FF6161";
      ctx.stroke();
      ctx.setLineDash([3, 3, 3]);
      ctx.moveTo(x, y);
      ctx.lineTo(x, y + h);
      ctx.stroke();
      ctx.setLineDash([3, 3, 3]);
      ctx.moveTo(x + w, y);
      ctx.lineTo(x + w, y + h);
      ctx.stroke();
      ctx.setLineDash([3, 3, 3]);
      ctx.moveTo(x, y + h);
      ctx.lineTo(x + w, y + h);
      ctx.stroke();

      // 删除小圆圈
      //   let ctx = this.canvas.getContext("2d");
      ctx.drawImage(this.imgObj, x - 15, y - 15, 30, 30);
      this.roundP.x = x - 15;
      this.roundP.y = y - 15;
      this.roundP.w = 30;
      this.roundP.h = 30;
    },
    //画图
    draw(active) {
      let ctx = this.canvas.getContext("2d");
      ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      ctx.beginPath();
      if (this.cBgImg !== "") {
        ctx.drawImage(this.cBgImg, 0, 0, this.canvas.width, this.canvas.height);
      }
      if (this.cardStore.length === 0) return;
      this.cardStore.map((val) => {
        ctx.drawImage(val.canvas, val.x, val.y, val.w, val.h);
      });

     active != "save" ? this.select():""
    },
    // canvas 画板初始化
    getCanvas() {
      const canvas = this.$refs.canvas;
      canvas.width = window.screen.width;
      canvas.height = "314";
      this.canvas = canvas;

      // 监听手指动作
      this.canvas.addEventListener("touchstart", this.start, false);
      this.canvas.addEventListener("touchend", this.end, false);

      //设置删除小圆图片
      let imgObj = new Image();
      imgObj.src = require("../../../../assets/gift/de.png");
      this.imgObj = imgObj;
    },
    //手指进入
    start(e) {
      e.preventDefault();
      if (e.touches.length >= 2) {
        this.is_touches = true;
        this.pstart = e.touches;
        return;
      } else {
        this.is_touches = false;
      }

      let { clientX, clientY } = e.targetTouches[0];
      let x = clientX - this.canvas.offsetLeft;
      let y = clientY - this.canvas.offsetTop;

      // 删除小圆圈
      let rx = this.roundP.x;
      let ry = this.roundP.y;
      let rw = this.roundP.w;
      let rh = this.roundP.h;
      // 删除指定元素
      if (x < rw + rx && y < rh + ry && x > rx && y > ry) {
        this.cardStore.splice(this.index, 1);
        this.draw();
      }

      //选中的元素
      this.cardStore.map((v, i) => {
        if (x < v.x + v.w && y < v.y + v.h && x > v.x && y > v.y) {
          this.index = i;
          this.canvas.addEventListener("touchmove", this.move, false);
          this.draw();
        }
      });
    },
    //手指移动
    move(e) {
      e.preventDefault();

      if (e.touches.length >= 2 && this.is_touches) {
        this.enlarge(e);
        return;
      }

      let { clientX, clientY } = e.targetTouches[0];
      let x = clientX - e.target.offsetLeft - this.cardStore[this.index].w / 2;
      let y = clientY - e.target.offsetTop - this.cardStore[this.index].h / 2;

      let px = parseInt(x + (x - this.cardStore[this.index].x) / 5);
      let py = parseInt(y + (y - this.cardStore[this.index].y) / 5);

      this.cardStore[this.index].x = px;
      this.cardStore[this.index].y = py;
      this.draw();
    },

    // 计算两个手指距离
    getDistance(p1, p2) {
      let x = p2.pageX - p1.pageX,
        y = p2.pageY - p1.pageY;
      return Math.sqrt(x * x + y * y);
    },
    //放大
    enlarge(e) {
      e.preventDefault();
      let now = e.touches;
      let scale =
        this.getDistance(now[0], now[1]) /
        this.getDistance(this.pstart[0], this.pstart[1]);
      // console.log(scale)
      scale = scale.toFixed(2);

      if (this.cardStore[this.index].scale < scale) {
        this.cardStore[this.index].scale = scale;
        this.cardStore[this.index].w =
          this.cardStore[this.index].w + (scale - 0.5);
        this.cardStore[this.index].h =
          this.cardStore[this.index].h + (scale - 0.5);
      } else {
        this.cardStore[this.index].scale = scale;
        this.cardStore[this.index].w =
          this.cardStore[this.index].w + (scale - 3);
        this.cardStore[this.index].h =
          this.cardStore[this.index].h + (scale - 3);
      }
      this.draw();
      // console.log(e)
    },
    //手指离开
    end(e) {
      e.preventDefault();
    },
    //旋转
    rotate(val) {
      if (this.cardStore.length === 0) return;
      let canvas = this.cardStore[this.index].canvas;
      let w = this.cardStore[this.index].canvas.width;
      let h = this.cardStore[this.index].canvas.height;
      this.cardStore[this.index].ro = val;
      let ctx = canvas.getContext("2d");
      ctx.clearRect(-w, -h, w * 10, h * 10);
      ctx.translate(0 + w / 2, 0 + h / 2);
      console.log(val);
      ctx.rotate((val * Math.PI) / (180 * val));
      ctx.translate(-(0 + w / 2), -(0 + h / 2));
      if (this.cardStore[this.index].fs) {
        ctx.fillText(
          this.cardStore[this.index].img,
          canvas.width / 2,
          canvas.height / 2
        );
      } else {
        ctx.drawImage(
          this.cardStore[this.index].img,
          0,
          0,
          canvas.width,
          canvas.height
        );
      }
      this.draw();
    },
    //设置背景图
    bgimg(bgimg) {
      console.log(bgimg);
      let that = this;
      let img = document.createElement("img");
      img.src = bgimg;
      img.onload = function () {
        that.cBgImg = this;
        that.draw();
      };
    },
    //选中的图案
    selectImg(val) {
      let obj = {
        w: 0,
        h: 0,
        x: 0,
        y: 0,
        ro: 0,
        img: "",
        canvas: "",
      };
      let can = document.createElement("canvas");
      let content = can.getContext("2d");

      can.width = obj.w = 50;
      can.height = obj.h = 50;

      content.drawImage(val, 0, 0, can.width, can.height);
      obj.img = val;
      obj.canvas = can;
      obj.x = this.canvas.width / 2 - 25;
      obj.y = this.canvas.height / 2 - 25;
      this.cardStore.push(obj);
      this.index = this.cardStore.length - 1;
      this.draw();
    },
    //设定文字
    setText(val) {
      let can = document.createElement("canvas");
      let context = can.getContext("2d");
      let fontsize = 10;
      can.width = fontsize * val.length;
      can.height = fontsize * val.length;
      context.font = `${fontsize}px bold 黑体`;
      // 设置水平对齐方式
      context.textAlign = "center";
      // 设置垂直对齐方式
      context.textBaseline = "middle";
      context.fillStyle = "black";
      context.fillText(val, can.width / 2, can.height / 2);
      let obj = {
        w: can.width,
        h: can.height,
        x: this.canvas.width / 2 - can.width,
        y: this.canvas.height / 2 - can.height,
        ro: 0,
        img: val,
        canvas: can,
        fs: fontsize,
        color: "",
      };

      this.cardStore.push(obj);
      this.draw();
    },
    //设定颜色
    selectColor(val) {
      let ele = this.cardStore[this.index];
      if (ele.fs == undefined || ele.fs == "") return;
      let ctx = ele.canvas.getContext("2d");
      ctx.clearRect(0, 0, ele.canvas.width, ele.canvas.height);
      ctx.fillStyle = val;
      ctx.font = `${ele.fs}px bold 黑体`;
      ctx.fillText(ele.img, ele.canvas.width / 2, ele.canvas.height / 2);
      this.draw();
    },
    //下一步
    nextStep(next) {
      if (next === 1 && this.step !== 0) {
        this.step--;
        return;
      }
      if (next === 2 && this.step !== 3) {
        this.step++;
      }
     
    },
    //退出
    quit(show) {
      // console.log(show,123456)
      this.nextBtnShow = show;
    },
    
  save() {//下载图片地址和图片名
      // const   imgsrc =  this.canvas.toDataURL("image/png");
  var image = new Image();
  // 解决跨域 Canvas 污染问题
  image.setAttribute("crossOrigin", "anonymous");
  image.onload = function() {
    var canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    var context = canvas.getContext("2d");
    context.drawImage(image, 0, 0, image.width, image.height);
    var url = canvas.toDataURL("image/png");
    var a = document.createElement("a"); // 生成一个a元素
    var event = new MouseEvent("click"); // 创建一个单击事件
    a.download =  "photo"; // 设置图片名称
    a.href = url; // 将生成的URL设置为a.href属性
    a.dispatchEvent(event); // 触发a的单击事件
  };
  image.src = this.canvas.toDataURL("image/png");
  this.draw("save")
},

    // save(){
    //   const image = this.canvas.toDataURL("image/png");
    //    var alink = document.createElement("a");
    //   alink.href = image;
    //   alink.download = "pic"; //图片名
    //   alink.click();

    //   // console.log(image)
    // }
  },
  
  mounted() {
    this.getCanvas();
  },
};
</script>
<style lang="scss" scoped>
.canvas {
  font-size: 0.32rem;
  .next {
    padding: 0.8rem 0;
    text-align: center;
    background: white;
    @include flexBox(space-around);
    button {
      background: #ffc44e;
      color: white;
      width: 3rem;
      height: 0.69rem;
      border-radius: 30px;
      border: none;
      display: inline-block;
      ~ button {
        background: #ff6161;
      }
    }
  }
  .btn{
    border-top: 1px solid #e4e4e4;
    margin-top: 0.3rem;
    text-align: center;
    padding-top: 0.5rem;
    button{
      width: 4.68rem;
      height: 0.88rem;
      border-radius: 30px;
      color: white;
      background: #FFC44E;
      border: none;
      margin: 0.2rem;
      &:nth-child(2){
        background:white ;
        border: 1px solid #FF6161;
        color:#FF6161;
      }
    }
  }
}
</style>